import * as React from "react";
import IncomeRequired from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import IncomeFromPension from "./IncomeFromPension";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SectionHeader } from "../../../Common/SharedComponents";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { getChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import {
    incomePaymentDetailsLabels,
    incomePaymentDetailsMessages,
} from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { IncomeReview } from "../../../Common/SIPP/DrawdownDetails/IncomeReview";
import { addYears } from "../../../../../../../react-core/utils/date";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { IncomePaymentDestination } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";

interface IIncomePaymentProps extends IProcessComponentProps {
    data: PensionContribution;
    allBankAccounts?: BankAccount[];
    onChange: (changes) => void;
}

interface IIncomePaymentState {}

export class IncomePayment extends ProcessComponent<IIncomePaymentProps, IIncomePaymentState> {
    constructor(props: any) {
        super(props);
    }

    private onDrawdownIncomeAmendmentInstructionChange = (changes: DrawdownIncomeAmendmentInstruction) => {
        const { data, onChange } = this.props;
        this.onDataChange(
            onChange,
            changes,
            data,
            "DrawdownIncomeAmendmentModel"
        )
    };

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const hasBankDestination = data?.DrawdownModel?.Income?.IncomePaymentAllocations?.some(alloc => alloc.Destination == IncomePaymentDestination.BankAccount);
        const bankAccountDestinations = data?.DrawdownModel?.Income?.IncomePaymentAllocations?.filter
            (alloc => alloc.Destination == IncomePaymentDestination.BankAccount).map(x => x.BankAccountId) ?? [];
        const hasInternationalBankAccountDestination = bankAccountDestinations?.some(x => {
            var allBankAccounts = this.props?.allBankAccounts ?? [];
            const bankAccount = allBankAccounts.find((ba) => ba.BankAccountId === x);
            return bankAccount && bankAccount.BankCountry !== CountryCode.GBR;
        });

        return (
            <>
                <IncomeRequired
                    data={data?.DrawdownModel?.Income}
                    onChange={(v) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "DrawdownModel"),
                            v,
                            data.DrawdownModel,
                            "Income"
                        );

                        if (data?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction) {
                            this.onDataChange(
                                (changes) => this.onDataChange(
                                    this.onDrawdownIncomeAmendmentInstructionChange,
                                    changes,
                                    data.DrawdownIncomeAmendmentModel,
                                    "DrawdownIncomeAmendmentInstruction"
                                ),
                                v,
                                data.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction,
                                "Income"
                            );
                        }
                    }}
                    labels={incomePaymentDetailsLabels}
                    messages={incomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={data?.DrawdownModel?.DrawdownType}
                    pensionTransfer={data?.PensionTransfers}
                    regularCrystalDifferentInital={
                        data?.DrawdownModel?.RegularCrystallisationDetails?.HasADifferentInitialAmount
                    }
                    processType={processTypeEnum.topUpWithITFLS}
                    pensionBase={data}
                    isITFC={true}
                    hasCappedArrangement={!isNullOrEmpty(data?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements)}
                />
                {data?.DrawdownModel?.Income?.TargetSpecificArrangements && (
                    <IncomeFromPension
                        data={data}
                        processType={processTypeEnum.topUpWithITFLS}
                        onChange={(changes) => {
                            this.onDataChange(onChange, changes, data);
                        }}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onDrawdownIncomeAmendmentInstructionChange={(changes)=>this.onDrawdownIncomeAmendmentInstructionChange(changes)}
                    />
                )}
                {/* <IncomeReview
                    data={
                        this.props.data == null
                            ? {
                                    DrawdownIncomeReviewDetails: {
                                        IncomeReviewDate: addYears(new Date(), 1),
                                        IncomeReviewFrequency: Frequency.Monthly,
                                        IncomeReviewFrequencyCount: 12,
                                    },
                                }
                            : this.props.data
                    }
                    onChange={(v) => this.onDataChange(onChange, v, data)}
                    onRef={(ref) => this.appendChild(ref)}
                /> */}
                <RegularIncomePayment
                    data={data.DrawdownModel?.Income}
                    onChange={(changes) => {
                        const changedIncome = { ...data.DrawdownModel.Income, ...changes };
                        const changedDrawdown = { ...data.DrawdownModel, ...{ Income: changedIncome } };
                        this.onDataChange(onChange, changedDrawdown, data, "DrawdownModel");
                    }}
                    labels={incomePaymentDetailsLabels}
                    messages={incomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={data?.DrawdownModel?.DrawdownType}
                    availableCash={data?.DrawdownModel?.CrystallisationDetails?.AvailableCash?.Amount}
                    taxFreeLumpSum={data?.DrawdownModel?.TaxFreeLumpSum?.Amount}
                    regularCrystallisationDetails={data?.DrawdownModel?.RegularCrystallisationDetails}
                    shouldHidePaymentMethod={!hasBankDestination}
                    pensionBase={data}
                    processType={processTypeEnum.topUpWithITFLS}
                    isITFC={true}
                    subaccountHierarchyid={getQueryParameters()["subaccounthierarchyid"]}
                    hasInternationalBankAccountDestination={hasInternationalBankAccountDestination}
                    sellableAssets={getChooseAssetsToSellTable(data)}
                />

                {data?.DrawdownModel.DrawdownType !== DrawdownType.Regular &&
                    SectionHeader("Choose assets to sell to pay income")}
                {data?.DrawdownModel.DrawdownType !== DrawdownType.Regular && (
                    <>
                        <p>
                            Disinvestment from post-retirement to meet income payments
                            <span>
                                (
                                {MoneyDisplayHelper.getMoneyFormat({
                                    Amount: data?.DrawdownModel.Income?.TargetSpecificArrangements
                                        ? data.DrawdownModel?.Income?.GrossIncomePerPaymentFromPension?.Amount
                                        : data.DrawdownModel?.Income?.GrossIncomePerPayment?.Amount,
                                    Currency: CurrencyCode.GBP,
                                })}
                                )
                            </span>
                        </p>
                        <RadiosEditor
                            options={[true, false]}
                            label={"Choose asset selection method"}
                            getText={(v) => (v ? "Proportionally across all assets" : "From specified assets")}
                            onChange={(v) => {
                                this.onDataChange(
                                    onChange,
                                    {
                                        IncomeDisinvestmentAllocations: [],
                                        IsAcrossAllAssets: v,
                                    },
                                    data,
                                    "DrawdownModel"
                                );
                            }}
                            tooltip={
                                "If there is insufficient value in an asset at the time of the sale, we will default to disinvesting proportioanlly from the assets selected."
                            }
                            cssWrapper={"rg-inline mb-10"}
                            selected={data?.DrawdownModel?.IsAcrossAllAssets}
                        />
                    </>
                )}
                {data?.DrawdownModel &&
                    !(data.DrawdownModel?.DrawdownType === DrawdownType.Regular) &&
                    data.DrawdownModel.IsAcrossAllAssets === false && (
                        <ChooseAssetsToSellTable
                            modelData={data?.DrawdownModel}
                            data={data?.DrawdownModel?.IncomeDisinvestmentAllocations}
                            tableData={getChooseAssetsToSellTable(data)}
                            onRef={(ref) => this.appendChild(ref)}
                            onChange={(v) => {
                                this.onDataChange(
                                    onChange,
                                    { IncomeDisinvestmentAllocations: v },
                                    data,
                                    "DrawdownModel"
                                );
                            }}
                            processType={ProcessType.TopUpWithITFLS}
                            reason={ChooseAssetsToSellFor.Income}
                            showErrorMsgPopUp={(msg, isShow) => showErrorMsgPopUp(msg, isShow)}
                        />
                    )}
            </>
        );
    }
}

export default IncomePayment;
function showErrorMsgPopUp(msg: string[], isShow: boolean): void {
    throw new Error("Function not implemented.");
}
